// 1. 导入Vue和Vue Router
import Vue from 'vue'
import VueRouter from 'vue-router'

// 2. 导入需要路由的组件
import Agreement from '@/components/xieyi.vue'//协议
import HelloWorld from '@/components/HelloWorld.vue'
import demandHome from '@/components/demand/demandHome'
import demandIndex from '@/components/demand/demandIndex'
import demanDatails from '@/components/demand/demanDatails'//需求详情
import demandOrder from '@/components/demand/demandOrder'  //订单列表
import demanYaoqing from '@/components/demand/demanYaoqing'  //邀请列表
import orderDatalis from '@/components/demand/orderDatalis'  //订单详情
import demandinvitedList from '@/components/demand/invitedList'
import demandinvoiceList from '@/components/demand/invoiceList'
import demandUserInfo from '@/components/demand/UserInfo'
import Reviewdatails from '@/components/demand/Reviewdatails'//评审详情
import message from '@/components/demand/message'//评审详情
import demandPromotion from '@/components/demand/demandPromotion'//我的推广
import messagelist from '@/components/demand/messagelist'//我的消息
import InvitDatails from '@/components/demand/InvitDatails'//我的消息
import AddMessage from '@/components/demand/AddMessage'//留言
import orderInvoice from '@/components/demand/orderInvoice'//订单查看单个历史开票
import InitiateReview from '@/components/demand/InitiateReview'//发起评审
import Addemand from '@/components/demand/Addemand' //服务方 提交需求
import demandFeedback from '@/components/demand/Feedback' //需求方 意见反馈


import serviceHome from '@/components/service/serviceHome'
import serviceIndex from '@/components/service/serviceIndex'
import serviceOrder from '@/components/service/serviceOrder' //服务方我的订单
import invitedList from '@/components/service/invitedList' //服务方被邀请
import myQuote from '@/components/service/myQuote' //服务方被邀请
import orderDatails from '@/components/service/orderDatails' //服务方被邀请
import serviceMy from '@/components/service/my' //服务方被邀请
import quoteDatails from '@/components/service/quoteDatails' //服务方被邀请详情
import invitedDatails from '@/components/service/invitedDatails' //服务方被邀请详情
import MyWallet from '@/components/service/MyWallet' //服务方我的钱包
import MyReview from '@/components/service/MyReview' //服务方我的评审
import UserInfo from '@/components/service/UserInfo' //服务方我的个人信息
import MyReviewDatails from '@/components/service/MyReviewDatails' //服务方我的评审详情
import servicedatails from '@/components/service/servicedatails' //服务方我的评审详情
import servicmessage from '@/components/service/message' //服务方我的留言
import AddReviewDatails from '@/components/service/AddReviewDatails' //服务方提交评审材料
import serviceReviewdatails from '@/components/service/Reviewdatails' //服务方提交评审材料
import SubmitMaterials from '@/components/service/SubmitMaterials' //服务方 提交评审材料
import Submitmessagelist from '@/components/service/messagelist' //服务方 提交评审材料
import serviceFeedback from '@/components/service/Feedback' //需求方 意见反馈
import ServicePromotion from '@/components/service/ServicePromotion' //需求方 意见反馈
// 3. 安装Vue Router插件
Vue.use(VueRouter)

// 4. 定义路由规则
const routes = [
  {
    path: '/',              // 默认首页：登录页
    name: 'home',
    component: HelloWorld
  },
  {
    path: '/Agreement',              // 默认首页：登录页
    name: 'Agreement',
    component: Agreement
  },
  {
    path: '/demandHome',    // 需求方首页
    name: 'demandHome',
    component: demandHome,
	children: [
	  {
	    path: 'demandIndex',   // 需求方 首页
	    component: demandIndex,
		children: [
			{
				path: 'demanDatails',   // 需求方 需求详情
				component: demanDatails
			},
			{
				path: 'demanYaoqing',   // 需求方 需求详情
				component: demanYaoqing
			},
			{
				path: 'Addemand',   // 需求方 需求详情
				component: Addemand
			}
		]
	  },
	  {
	    path: 'demandOrder',   // 需求方 我的订单列表
	    component: demandOrder,
		children: [
			{
			  path: 'orderDatalis',   // 需求方 订单详情
			  component: orderDatalis
			},
			{
			  path: 'Reviewdatails',   // 需求方 评审详情
			  component: Reviewdatails
			},
			{
			  path: 'message',   // 需求方 留言
			  component: message
			},
			{
			  path: 'AddMessage',   // 需求方 评审详情
			  component: AddMessage
			},
			{
			  path: 'orderInvoice',   // 需求方 订单开票历史
			  component: orderInvoice
			},
			{
			  path: 'InitiateReview',   // 需求方 订单开票历史
			  component: InitiateReview
			},
		]
	  },
	  {
	    path: 'demandinvitedList',   // 需求方 邀请记录
	    component: demandinvitedList,
		children: [
			{
			  path: 'InvitDatails',   // 需求方 订单详情
			  component: InvitDatails
			},
		]
	  },
	  {
	    path: 'demandinvoiceList',   //需求方 历史开票
	    component: demandinvoiceList
	  },
	  {
	    path: 'demandUserInfo',   //需求方 个人信息
	    component: demandUserInfo
	  },
	  {
	    path: 'demandPromotion',   //需求方 我的推广
	    component: demandPromotion
	  },
	  {
	    path: 'messagelist',   //需求方 我的消息
	    component: messagelist
	  },
	  {
	    path: 'demandFeedback',   //需求方 意见反馈
	    component: demandFeedback
	  }
	]
  },

  {
    path: '/serviceHome',   // 服务方首页
    name: 'serviceHome',
    component: serviceHome,
    children: [
      {
        path: 'serviceindex',   // 服务方首页要显示的内容
        component: serviceIndex,
		children: [
			{
			  path: 'servicedatails',   // 订单详情
			  component: servicedatails
			}
		]
      },
	  {
	    path: 'messagelist',   // 服务方首页要显示的内容
	    component: Submitmessagelist,
	  },
	  {
	    path: 'serviceOrder',   // 服务方首页要显示的内容
	    component: serviceOrder,
		children: [
			{
			  path: 'orderDatails',   // 订单详情
			  component: orderDatails
			},
			{
			  path: 'servicmessage',   // 服务方 留言
			  component: servicmessage
			},
			{
			  path: 'AddReviewDatails',   // 服务方 提交评审材料
			  component: AddReviewDatails
			},
			{
			  path: 'Reviewdatails',   // 服务方 提交评审材料
			  component: serviceReviewdatails
			},
			{
			  path: 'SubmitMaterials',   // 服务方 提交评审材料
			  component: SubmitMaterials
			}
		]
	  },
	  {
	    path: 'invitedList',   // 服务方首页要显示的内容
	    component: invitedList,
		children: [
			{
			  path: 'invitedDatails',   // 订单详情
			  component: invitedDatails
			},
		]
	  },
	  {
	    path: 'myQuote',   // 服务方我的报价
	    component: myQuote,
		children: [
			{
			  path: 'quoteDatails',   // 订单详情
			  component: quoteDatails
			}
		]
	  },
	  {
	    path: 'serviceMy',   // 服务方我的报价
	    component: serviceMy
	  },
	  {
	    path: 'MyWallet',   // 服务方首页要显示的内容
	    component: MyWallet
	  },
	  {
	    path: 'MyReview',   // 服务方首页要显示的内容
	    component: MyReview,
		children: [
			{
			  path: 'MyReviewDatails',   // 评审详情详情
			  component: MyReviewDatails
			}
		]
	  },
	  {
	    path: 'UserInfo',   // 服务方首页要显示的内容
	    component: UserInfo
	  },
	  {
	    path: 'serviceFeedback',   // 服务方意见反馈
	    component: serviceFeedback
	  },
	  {
	    path: 'ServicePromotion',   // 服务方意见反馈
	    component: ServicePromotion
	  },
	  
    ]
  },
]
// 5. 创建路由实例
const router = new VueRouter({
  mode: 'hash', // 路由模式（history或hash，下文详解）
  routes // 传入路由规则
})
router.afterEach((to) => {
  if (to.path === '/') {
    // 到首页后清空浏览器记录
    history.pushState(null, '', window.location.href.split('#')[0]);
  }
});

// 6. 导出路由实例
export default router